{
  "nl": {
    "search": {
      "placeholders": {
        "query": "Zoek op vragen of trefwoorden"
      },
      "title": "Zoeken"
    }
  }
}
